import { loadDevMessages, loadErrorMessages } from '@apollo/client/dev';
import { documentThemePreferenceStore } from '@words-happen/theme-preference';
import { WordsHappenThemeProvider } from '@words-happen/ui-components';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { apolloClient } from './api';
import Application from './application';
import { ModalController } from './components';
import { ApolloClientContextContainer, UserState } from './contexts';
import { SessionProvider } from './session';
import { AccountSettingsProvider } from './settings';
import '@words-happen/ui-components/ui-components.css';
import css from './main.module.scss';

const themePreference = documentThemePreferenceStore(SESSION_COOKIE_DOMAIN);

const clients = {
  default: apolloClient,
};

const __DEV__ = IS_DEVELOPMENT;

if (__DEV__) {
  // Adds messages only in a dev environment
  loadDevMessages();
  loadErrorMessages();
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ApolloClientContextContainer clients={clients}>
      <UserState>
        <Router>
          <SessionProvider>
            <AccountSettingsProvider>
              <WordsHappenThemeProvider store={themePreference} className={css.main}>
                <ModalController>
                  <Application />
                </ModalController>
              </WordsHappenThemeProvider>
            </AccountSettingsProvider>
          </SessionProvider>
        </Router>
      </UserState>
    </ApolloClientContextContainer>
  </React.StrictMode>,
);
